import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Code,
  Flex,
  Heading,
  Image,
  Link,
  Menu,
  MenuList,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  useBreakpointValue,
  useDisclosure,
} from "@chakra-ui/react";
// import { API } from "aws-amplify";
// import { useEffect, useState } from "react";
import { BsChevronDown } from "react-icons/bs";
import {
  Action,
  ActionButton,
  ActionText,
  CallToActions,
  Footer,
  FooterContainer,
  HeadingOne,
  Hero,
  Logo,
  MenuTopBar,
  MenuTopBarLink,
  SignoutButton,
  Subheading,
  TopBar,
  TopButton,
  TopButtons,
  TranslateInput,
  UserMenuButton,
} from "./styled";
import { Content } from "../utils/content";
// const languages = [
//   { label: "中文", code: "zh" },
//   { label: "KREYÒL", code: "ht" },
//   { label: "English", code: "en" },
//   { label: "FRANÇAIS", code: "fr" },
//   { label: "DEUTSCH", code: "de" },
//   { label: "ગુજરાતી", code: "gu" },
//   { label: "हिंदी", code: "hi" },
//   { label: "ITALIANO", code: "it" },
//   { label: "日本語", code: "ja" },
//   { label: "한국어", code: "ko" },
//   { label: "POLSKI", code: "pl" },
//   { label: "PORTUGUÊS", code: "pt" },
//   { label: "РУССКИЙ", code: "ru" },
//   { label: "ESPAÑOL", code: "es" },
//   { label: "TAGALOG", code: "tl" },
//   { label: "TIẾNG VIỆT", code: "vi" },
// ];

export function HomeScreen() {
  // const [language, setLanguage] = useState("en");
  const { isOpen, onOpen, onClose } = useDisclosure();
  // const [translations, setTranslations] = useState<Record<string, string>>({});
  // useEffect(() => {
  //   fetchContent();
  // }, [language]);

  // const handleChangeLanguage = (langValue: string) => {
  //   setLanguage(langValue);
  //   window.scrollTo({
  //     top: 0,
  //     left: 0,
  //     behavior: "smooth",
  //   });
  // };

  // async function fetchContent() {
  //   const environmentID = "34773487-d9f5-4041-9621-d5745a60d331";

  //   const content = (await API.graphql({
  //     query: `
  //       query MyQuery {
  //         requestContent(environmentID: "${environmentID}", language: "${language}") {
  //           body {
  //             key
  //             value
  //           }
  //         }
  //       }
  //       `,
  //   })) as any;

  //   const formattedData: any = {};
  //   content.data.requestContent.body.forEach((i: any) => {
  //     formattedData[i.key] = i.value;
  //   });
  //   setTranslations(formattedData);
  // }

  return (
    <>
      <TopBar>
        <Logo>
          <img
            alt="FluentC"
            src="https://fluentc.io/wp-content/uploads/fluentc-2.png"
            width="241px"
          />
        </Logo>
        <div>
          <TopButtons>
            <TopButton>Login</TopButton>
          </TopButtons>
        </div>
      </TopBar>
      <MenuTopBar>
        <div>
          <MenuTopBarLink>{Content["get-coverage"]}</MenuTopBarLink>
          <MenuTopBarLink>{Content["update-plan"]}</MenuTopBarLink>
          <Menu>
            <UserMenuButton>
              {Content["see-topics"]} <BsChevronDown />
            </UserMenuButton>
            <MenuList>
              <SignoutButton>{Content["create-an-account"]} </SignoutButton>
            </MenuList>
          </Menu>
          <MenuTopBarLink>{Content["get-answers"]} </MenuTopBarLink>
        </div>
        <TranslateInput placeholder={Content["search"]} />
      </MenuTopBar>
      <Hero>
        <HeadingOne>{Content["hero-1"]}</HeadingOne>
        <CallToActions>
          <Action>
            <ActionText>{Content["first-time"]}</ActionText>
            <ActionButton>{Content["take-the-first step"]}</ActionButton>
          </Action>
          <Action>
            <ActionText>
              {Content["already-have a-marketplace-plan"]}
            </ActionText>
            <ActionButton> {Content["log-in-to-renew"]}</ActionButton>
          </Action>
        </CallToActions>
        <Subheading>
          {Content["looking-for-coverage"]}
          <u> {Content["learn-more"]}</u>
        </Subheading>
      </Hero>
      <FooterContainer>
        <Footer>
          <div id="fluentc-widget"></div>
          {/* <div>
            {languages.map((l, i) => (
              <span key={l.code}>
                <FooterLink onClick={() => handleChangeLanguage(l.code)}>
                  {l.label}
                </FooterLink>
                {i !== languages.length - 1 ? " | " : ""}
              </span>
            ))}
          </div> */}
        </Footer>
      </FooterContainer>

      <Stack minH={"100vh"} direction={{ base: "column", md: "row" }}>
        <Flex p={8} flex={1} align={"center"} justify={"center"}>
          <Stack spacing={6} w={"full"} maxW={"lg"}>
            <Heading fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }}>
              <Text
                as={"span"}
                position={"relative"}
                _after={{
                  content: "''",
                  width: "full",
                  height: useBreakpointValue({ base: "15%", md: "30%" }),
                  position: "absolute",
                  bottom: 1,
                  left: 0,
                  bg: "blue.400",
                  zIndex: -1,
                }}
              >
                Start creating <br />
                multi-language content like the <br />
                header above using <br />
                FluentC
              </Text>
            </Heading>
            <Text fontSize={{ base: "md", lg: "lg" }} color={"gray.500"}>
              It is now easier than ever to manage all of your translations in
              one secure and safe platform
            </Text>
            <Stack direction={{ base: "column", md: "row" }} spacing={4}>
              <Link href="https://dashboard.fluentc.io" isExternal>
                <Button
                  rounded={"full"}
                  bg={"blue.400"}
                  color={"white"}
                  _hover={{
                    bg: "blue.500",
                  }}
                >
                  Register
                </Button>
              </Link>
              <Button onClick={onOpen} rounded={"full"}>
                How It Works
              </Button>
            </Stack>
            <br />

            <img
              alt="FluentC"
              src="https://fluentc.io/wp-content/uploads/fluentc-2.png"
              width="300px"
            />
          </Stack>
        </Flex>
        <Flex flex={1}>
          <Image
            alt={"Login Image"}
            objectFit={"cover"}
            src={
              "https://images.unsplash.com/photo-1527689368864-3a821dbccc34?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80"
            }
          />
        </Flex>
      </Stack>
      <Modal isOpen={isOpen} size={"xl"} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Steps to get Started</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <Accordion>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      Register for FluentC Account
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <img
                    src="http://www.fluentc.io/wp-content/uploads/SignUp.png"
                    alt="signup"
                  />
                  FluentC Credits required after Free Trial
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      Setup your Widget
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <img
                    src="https://ajeuwbhvhr.cloudimg.io/colony-recorder.s3.amazonaws.com/files/2023-06-26/18f7cc0c-1f6a-4920-b175-ea0c604836d1/ascreenshot.jpeg?tl_px=949,70&br_px=2442,910&force_format=png&width=560&wat_scale=50&wat=1&wat_opacity=0.7&wat_gravity=northwest&wat_url=https://colony-recorder.s3.us-west-1.amazonaws.com/images/watermarks/FB923C_standard.png&wat_pad=262,139"
                    alt="widget"
                  />
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      Setup your Application and Environments
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <img
                    src="https://ajeuwbhvhr.cloudimg.io/colony-recorder.s3.amazonaws.com/files/2023-06-26/171a424a-0845-4415-b804-87dd73a9ca74/ascreenshot.jpeg?tl_px=1021,50&br_px=2514,890&force_format=png&width=560&wat_scale=50&wat=1&wat_opacity=0.7&wat_gravity=northwest&wat_url=https://colony-recorder.s3.us-west-1.amazonaws.com/images/watermarks/FB923C_standard.png&wat_pad=262,139"
                    alt="application"
                  />
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      Setup the Languages for your Website
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <img
                    src="https://ajeuwbhvhr.cloudimg.io/colony-recorder.s3.amazonaws.com/files/2023-06-26/cb347814-a1a2-42b0-9f80-4de3914f17f3/ascreenshot.jpeg?tl_px=855,188&br_px=2348,1028&force_format=png&width=560&wat_scale=50&wat=1&wat_opacity=0.7&wat_gravity=northwest&wat_url=https://colony-recorder.s3.us-west-1.amazonaws.com/images/watermarks/FB923C_standard.png&wat_pad=262,139"
                    alt="language"
                  />
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      Finish Security Settings
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <img
                    src="https://ajeuwbhvhr.cloudimg.io/colony-recorder.s3.amazonaws.com/files/2023-06-26/0de23b93-d0ae-437d-930d-a44120a35020/ascreenshot.jpeg?tl_px=501,188&br_px=1994,1028&force_format=png&width=560&wat_scale=50&wat=1&wat_opacity=0.7&wat_gravity=northwest&wat_url=https://colony-recorder.s3.us-west-1.amazonaws.com/images/watermarks/FB923C_standard.png&wat_pad=262,139"
                    alt="security"
                  />
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      Install your Web Widget
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <Code children='<script src="https://widget.fluentc.io/fluentcWidget.min.js"></script>' />{" "}
                  <br />
                  <Code children="<script>" /> <br />
                  <Code children='    document.addEventListener("DOMContentLoaded", function () {' />
                  <Code children='          f=new fluentcWidget({widgetID: "Your Widget Code"})' />
                  <Code children="          f.setupWidget(&#39;fluentc-widget&#39;);" />
                  <Code children="     });" />
                  <Code children="</script>" />
                  <br /> Paste this code snippet where your website should list
                  available language.
                  <Code children="<div id=&#39;fluentc-widget&#39;></div>" />
                  <br />
                  <br />
                  For all of the options visit our{" "}
                  <Link href="https://docs.fluentc.io" isExternal>
                    Documentation
                  </Link>
                </AccordionPanel>
              </AccordionItem>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box as="span" flex="1" textAlign="left">
                      It is that simple
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  <img
                    src="http://www.fluentc.io/wp-content/uploads/Screenshot-2023-04-24-at-11.24.07-PM.png"
                    alt="demo"
                  />
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          </ModalBody>

          <ModalFooter>
            <Link href="https://dashboard.fluentc.io" isExternal>
              <Button variant="ghost">Register Now</Button>
            </Link>
            <Button colorScheme="blue" mr={3} onClick={onClose}>
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
